export default {
  PACKAGE: 'PACKAGE',
  TICKET: 'TICKET',
  COVER: 'COVER',
  //
  FLOWER: 'FLOWER',
  PRE_ROLLS: 'PRE_ROLLS',
  VAPORIZERS: 'VAPORIZERS',
  CONCENTRATES: 'CONCENTRATES',
  EDIBLES: 'EDIBLES',
  TOPICALS: 'TOPICALS',
  TINCTURES: 'TINCTURES',
  ACCESSORIES: 'ACCESSORIES',
  //
  PICK_UP_TIME: 'PICK_UP_TIME',
}



// WEBPACK FOOTER //
// ./src/constants/inventoryTypes.js